import { BasicProperties } from "../view/BasicProperties";

export class BasicDialogVO {
    public key: Object;
    public priority: number;
    public delay: number;
    public properties: BasicProperties;
    public blockDialogs: boolean;
}

